/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
export var TimeZone;
(function (TimeZone) {
    TimeZone["UTC"] = "UTC";
})(TimeZone || (TimeZone = {}));
